import {Injectable} from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoggerService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  log(msg: any) {
    console.log(msg);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error(msg: any) {
    console.error(msg);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  warn(msg: any) {
    console.warn(msg);
  }
}
